module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAATElEQVQ4y83UwQkAIAwDwIADOJKrdyQHKMSICDpB09/9QkoLPjNRrMCdYaBGRicd1FOhmHCQ+tG2PLST4WupTmdjCQcplI2Mbtrn1y34HNoV8/zRmgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xM1QxNToyNzowOCswOTowMBCC6ssAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjIrMDk6MDA/qCjNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_01623_100x100.png
// module id = ihNt
// module chunks = 0